<template>
        <ul class="n2-valid" v-bind:class="{'n2-errors':errors}">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
</template>
<script>
    export default {
        props: ['errors']
    }
</script>
